module.exports = __webpack_public_path__ + "img/AdobeStock_237102404.1ea29d59.jpeg";